module.exports = __webpack_public_path__ + "img/pizzarouge_on.fb9769b9.gif";